import {IRange} from "@pg-design/inputs-module";
import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const propertyListHitAlgolytics = delayHit((payload: Object) => hitAlgolytics("search_property_list", payload), 500);

export const searchPropertyListHit = (
    formValues: Record<string, Record<string, number> | IRange<number | string>>,
    propertiesId: number[],
    offerId: number
) => {
    const payload = {
        ...getTrackedSiteData(),
        property_id: propertiesId,
        offer_id: offerId,
        ...(formValues.area?.lower && {search_area_lower: formValues.area.lower}),
        ...(formValues.area?.upper && {search_area_upper: formValues.area.upper}),
        ...(formValues.rooms?.lower && {search_rooms_lower: formValues.rooms.lower}),
        ...(formValues.rooms?.upper && {search_rooms_upper: formValues.rooms.upper}),
        ...(formValues.floor?.lower && {search_floor_lower: formValues.floor.lower}),
        ...(formValues.floor?.upper && {search_floor_upper: formValues.floor.upper}),
        ...(formValues.price?.lower && {search_price_lower: formValues.price.lower}),
        ...(formValues.price?.upper && {search_price_upper: formValues.price.upper}),
        ...(formValues.price_m2?.lower && {search_price_m2_lower: formValues.price_m2.lower}),
        ...(formValues.price_m2?.upper && {search_price_m2_upper: formValues.price_m2.upper})
    };

    propertyListHitAlgolytics(payload);
};
import {IRange} from "@pg-design/inputs-module";
import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const propertyListHitAlgolytics = delayHit((payload: Object) => hitAlgolytics("search_property_list", payload), 500);

export const searchPropertyListHit = (
    formValues: Record<string, Record<string, number> | IRange<number | string>>,
    propertiesId: number[],
    offerId: number
) => {
    const payload = {
        ...getTrackedSiteData(),
        property_id: propertiesId,
        offer_id: offerId,
        ...(formValues.area?.lower && {search_area_lower: formValues.area.lower}),
        ...(formValues.area?.upper && {search_area_upper: formValues.area.upper}),
        ...(formValues.rooms?.lower && {search_rooms_lower: formValues.rooms.lower}),
        ...(formValues.rooms?.upper && {search_rooms_upper: formValues.rooms.upper}),
        ...(formValues.floor?.lower && {search_floor_lower: formValues.floor.lower}),
        ...(formValues.floor?.upper && {search_floor_upper: formValues.floor.upper}),
        ...(formValues.price?.lower && {search_price_lower: formValues.price.lower}),
        ...(formValues.price?.upper && {search_price_upper: formValues.price.upper}),
        ...(formValues.price_m2?.lower && {search_price_m2_lower: formValues.price_m2.lower}),
        ...(formValues.price_m2?.upper && {search_price_m2_upper: formValues.price_m2.upper})
    };

    propertyListHitAlgolytics(payload);
};
